import httpService from "../httpService";
import utils from "../utils";

export const vbOutgoingDocUserTdhvpViewService = {
  findAll(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/vbOutgoingDocUserTdhvpView", { params: params });
  },

  findById(id) {
    return httpService.get(`/vbOutgoingDocUserTdhvpView/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/tdhvp/vbOutgoingDocUserTdhvpViewService.js